import React from 'react';
import PropTypes from 'prop-types';
import { ContentBoxContainer, ContentBoxText, ContentBoxFigure, Spacer, PenlySeo } from 'components';
import ReactMarkdown from 'react-markdown';

const PageContent = ({ title, subtitle, text, image, meta_description, centerImage }) => {
    const fullWidthStyle = { width: '100%', flexBasis: 'unset' };
    let figureClasses = 'btrl';
    if (centerImage) {
        figureClasses += ' centered';
    }
    return (
        <>
            <PenlySeo title={ title } description={ meta_description } image={ image } />
            <ContentBoxContainer>
                <ContentBoxText style={ image ? {} : fullWidthStyle }>
                    <h1>{ title }</h1>
                    <h4 className="lowerCase">{ subtitle }</h4>
                    <ReactMarkdown source={ text } />
                </ContentBoxText>
                { image && <ContentBoxFigure className={ figureClasses } figure={ image.url }></ContentBoxFigure> }
            </ContentBoxContainer>
        </>
    );
};

PageContent.defaultProps = {};

PageContent.propTypes = {};

export default PageContent;
